import { fullDateFormat } from 'constants/dateFormats'
import { dateService } from 'services/date.service'

export const getFullDate = (value: string, format?: string): string =>
  value ? dateService.getDate(value).format(format || fullDateFormat) : ''
